import React, { useState, useEffect } from 'react';

const Slideshow = ({ images, isPaused, onPause, onResume }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [isPaused, images.length]);

  return (
    <div 
      className="relative w-full max-w-lg mx-auto" 
      onMouseEnter={onPause} 
      onMouseLeave={onResume}
    >
      <img
        src={images[currentIndex]}
        alt={`Slika ${currentIndex + 1}`}
        className="w-full h-auto rounded-lg"
      />
    </div>
  );
};

export default Slideshow;
